module.exports = __webpack_public_path__ + "img/celebrate.71530d7d.svg";